var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/setting-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 17.5625C13.9425 17.5625 13.6875 17.3075 13.6875 17V8.75C13.6875 8.4425 13.9425 8.1875 14.25 8.1875C14.5575 8.1875 14.8125 8.4425 14.8125 8.75V17C14.8125 17.3075 14.5575 17.5625 14.25 17.5625Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.25 6.3125C13.9425 6.3125 13.6875 6.0575 13.6875 5.75V2C13.6875 1.6925 13.9425 1.4375 14.25 1.4375C14.5575 1.4375 14.8125 1.6925 14.8125 2V5.75C14.8125 6.0575 14.5575 6.3125 14.25 6.3125Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 17.5625C8.6925 17.5625 8.4375 17.3075 8.4375 17V13.25C8.4375 12.9425 8.6925 12.6875 9 12.6875C9.3075 12.6875 9.5625 12.9425 9.5625 13.25V17C9.5625 17.3075 9.3075 17.5625 9 17.5625Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9 10.8125C8.6925 10.8125 8.4375 10.5575 8.4375 10.25V2C8.4375 1.6925 8.6925 1.4375 9 1.4375C9.3075 1.4375 9.5625 1.6925 9.5625 2V10.25C9.5625 10.5575 9.3075 10.8125 9 10.8125Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.75 17.5625C3.4425 17.5625 3.1875 17.3075 3.1875 17V8.75C3.1875 8.4425 3.4425 8.1875 3.75 8.1875C4.0575 8.1875 4.3125 8.4425 4.3125 8.75V17C4.3125 17.3075 4.0575 17.5625 3.75 17.5625Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.75 6.3125C3.4425 6.3125 3.1875 6.0575 3.1875 5.75V2C3.1875 1.6925 3.4425 1.4375 3.75 1.4375C4.0575 1.4375 4.3125 1.6925 4.3125 2V5.75C4.3125 6.0575 4.0575 6.3125 3.75 6.3125Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.25 9.3125H2.25C1.9425 9.3125 1.6875 9.0575 1.6875 8.75C1.6875 8.4425 1.9425 8.1875 2.25 8.1875H5.25C5.5575 8.1875 5.8125 8.4425 5.8125 8.75C5.8125 9.0575 5.5575 9.3125 5.25 9.3125Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.75 9.3125H12.75C12.4425 9.3125 12.1875 9.0575 12.1875 8.75C12.1875 8.4425 12.4425 8.1875 12.75 8.1875H15.75C16.0575 8.1875 16.3125 8.4425 16.3125 8.75C16.3125 9.0575 16.0575 9.3125 15.75 9.3125Z",
    fill: "#8B8C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.5 10.8125H7.5C7.1925 10.8125 6.9375 10.5575 6.9375 10.25C6.9375 9.9425 7.1925 9.6875 7.5 9.6875H10.5C10.8075 9.6875 11.0625 9.9425 11.0625 10.25C11.0625 10.5575 10.8075 10.8125 10.5 10.8125Z",
    fill: "#8B8C8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.4bf5c48446cad067b62d67df1438eaf0.svg";
export { ForwardRef as ReactComponent };